// ── Field type thresholds ────────────────────────────────────────────

export const TITLE_LIMITS = {
    minChars: 30,
    optimalMinChars: 40,
    optimalMaxChars: 80,
    maxChars: 200,
    minWords: 4,
    maxWords: 20,
    keywordPositionMax: 60,
};

export const DESCRIPTION_LIMITS = {
    minChars: 100,
    optimalMinChars: 150,
    optimalMaxChars: 600,
    maxChars: 2000,
    maxSentenceWords: 25,
    maxKeywordDensityPer500: 4,
    metaDescriptionLength: 160,
};

export const BULLET_LIMITS = {
    minChars: 40,
    optimalMinChars: 80,
    optimalMaxChars: 220,
    maxChars: 300,
    minCount: 3,
    maxCount: 7,
};

// ── Scoring weights ─────────────────────────────────────────────────

export const SCORE_WEIGHTS = {
    title: 0.30,
    description: 0.30,
    bullets: 0.25,
    listing: 0.15,
};

export const PENALTY = {
    critical: 20,
    warning: 10,
    bonus: 5,
};

export const GRADES = [
    {min: 90, grade: 'A', label: 'Excellent', color: 'teal'},
    {min: 75, grade: 'B', label: 'Good', color: 'teal'},
    {min: 60, grade: 'C', label: 'Needs work', color: 'amber'},
    {min: 40, grade: 'D', label: 'Poor', color: 'coral'},
    {min: 0, grade: 'F', label: 'Critical', color: 'coral'},
];

// ── Power words (boost CTR in e-commerce) ───────────────────────────

export const POWER_WORDS = new Set([
    'premium', 'exclusive', 'handmade', 'organic', 'professional',
    'luxury', 'artisan', 'durable', 'lightweight', 'versatile',
    'ergonomic', 'innovative', 'certified', 'eco-friendly', 'sustainable',
    'heavy-duty', 'commercial-grade', 'hotel-grade', 'military-grade',
    'best-selling', 'award-winning', 'patented', 'guaranteed',
    'limited-edition', 'handcrafted', 'ultra', 'advanced', 'precision',
]);

// ── CTA / action words ──────────────────────────────────────────────

export const CTA_WORDS = new Set([
    'buy', 'shop', 'order', 'get', 'upgrade', 'transform', 'discover',
    'experience', 'enjoy', 'elevate', 'enhance', 'perfect', 'ideal',
    'designed', 'built', 'crafted', 'engineered', 'made',
]);

// ── Stop words (should not start a bullet) ──────────────────────────

export const STOP_WORDS = new Set([
    'the', 'a', 'an', 'and', 'or', 'but', 'in', 'on', 'at', 'to',
    'for', 'of', 'with', 'by', 'from', 'is', 'are', 'was', 'were',
    'it', 'its', 'this', 'that', 'these', 'those', 'our', 'your',
    'has', 'have', 'had', 'be', 'been', 'being', 'will', 'can',
]);

// ── Filler words (dilute copy, common in AI output) ─────────────────

export const FILLER_WORDS = new Set([
    'very', 'really', 'just', 'actually', 'basically', 'literally',
    'truly', 'extremely', 'absolutely', 'completely', 'totally',
    'quite', 'rather', 'somewhat', 'simply', 'definitely',
    'certainly', 'obviously', 'clearly', 'honestly', 'frankly',
    'incredibly', 'amazingly', 'remarkably', 'exceptionally',
]);

// ── Passive voice indicators ────────────────────────────────────────

export const PASSIVE_MARKERS = [
    'is made', 'is designed', 'is built', 'is crafted', 'is constructed',
    'is created', 'is manufactured', 'is engineered', 'is produced',
    'is finished', 'is coated', 'is treated', 'is assembled',
    'was made', 'was designed', 'was built', 'was crafted',
    'are made', 'are designed', 'are built', 'are crafted',
    'been made', 'been designed', 'been built', 'been crafted',
    'being made', 'being used', 'being offered',
    'can be used', 'can be installed', 'can be adjusted',
    'will be shipped', 'will be delivered',
    'is guaranteed', 'is backed', 'is covered', 'is included',
    'is recommended', 'is suitable', 'is intended', 'is available',
];

// ── Key spec attributes (should be mentioned in content) ────────────

export const KEY_SPEC_VARS = new Set([
    'product_name', 'material', 'finish', 'color', 'size',
    'weight', 'dimensions', 'product_type', 'warranty',
]);

// ── Flesch readability thresholds ───────────────────────────────────

export const READABILITY = {
    ecommerceBest: 60,
    ecommerceMin: 45,
};

// ── Check status types ──────────────────────────────────────────────

export const CHECK_STATUS = {
    PASS: 'pass',
    WARN: 'warn',
    FAIL: 'fail',
    INFO: 'info',
    BONUS: 'bonus',
};
